/* eslint-disable react-hooks/exhaustive-deps */
/** @jsx jsx */
import { jsx } from '@emotion/core';
import { useEffect, useReducer, useState } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { getFormFields } from './AdvFormUtil';
import AdvFormActionButtons from './AdvFormActionButtons';
import AdvFormHeader from './AdvFormHeader';
import advFormStyles from '../../../styles/AdvancedFormSearch/AdvanceFormSearchStyles';
import AdvAppFormItem from './AdvAppFormItem';

const AdvFormSearch = ({
  handleFormChange = console.log,
  advFormData,
  setAdvFormData,
  handleAdvFormSearchClick,
  toggleAdvFormSearch,
  intlFormData,
  retainValues,
  acsMgmt,
  loginData,
  isForFileTrack = false,
  showSavedSearch = false,
  savedSearchList,
  onItemClick,
  resetHandlerTriggered,
  setFormErrorData,
}) => {
  const [pageData, setPageData] = useReducer(
    (value, newValue) => ({ ...value, ...newValue }),
    advFormData
  );

  useEffect(() => {
    handleFormChange(pageData);
  }, [pageData]);

  const [showSaveListPopup, setShowSaveListPopup] = useState(false);
  const handleFormSubmit = () => {
    const newPageData = { ...pageData };
    newPageData.formFields.forEach((field) => {
      if (field.value?.length < field?.minLength) {
        // eslint-disable-next-line no-param-reassign
        field.value = '';
      }
    });
    setAdvFormData(newPageData);
    handleAdvFormSearchClick(newPageData);
  };

  const handleFormReset = () => {
    const newPageData = { ...pageData };
    newPageData.formFields = [...newPageData.formFields];
    // eslint-disable-next-line no-plusplus
    for (let i = 0; i < newPageData.formFields.length; i++) {
      if (newPageData.formFields[i].type === 'date-time-range') {
        newPageData.formFields[i] = { ...newPageData.formFields[i], value: '' };
      } else if (newPageData.formFields[i].type === 'multi-select'
          || newPageData.formFields[i].type === 'multi-selectV2') {
        console.log('Logging HS - formFields multi-select ::', newPageData.formFields[i], intlFormData);
        const selectedIds = intlFormData.formFields[i].value.split(',').map((item) => Number.parseInt(item, 10));
        newPageData.formFields[i] = {
          ...newPageData.formFields[i],
          value: intlFormData.formFields[i].value,
          selectedIds,
        };
      } else if (newPageData.formFields[i].type === 'AdvFormSearchItemV2') {
        newPageData.formFields[i] = {
          ...newPageData.formFields[i],
          value: intlFormData.formFields[i].value,
          displayValue: intlFormData.formFields[i].displayValue,
        };
      } else {
        newPageData.formFields[i] = {
          ...newPageData.formFields[i],
          value: intlFormData.formFields[i].value,
        };
      }
    }
    const decidingOthersSuggestFields = _.filter(newPageData.formFields,
      // eslint-disable-next-line you-dont-need-lodash-underscore/is-nil
      (field) => !_.isNil(field.decidesSuggestListFor)
    );

    decidingOthersSuggestFields.forEach((field) => {
      const i = field.decidesSuggestListFor;
      newPageData.formFields[i] = {
        ...newPageData.formFields[i],
        suggestionList: [],
      };
    });
    setPageData(newPageData);
    setAdvFormData(newPageData);
    if (resetHandlerTriggered) {
      resetHandlerTriggered(newPageData);
    }
    if (setFormErrorData) {
      setFormErrorData([]);
    }
  };

  useEffect(() => {
    if (!retainValues && !isForFileTrack) {
      handleFormReset();
    }
  }, [retainValues]);

  useEffect(() => {
    if (pageData.formFields?.length > 0) {
      setPageData(advFormData);
    }
  }, [advFormData, advFormData.formFields]);

  const formFields = getFormFields(pageData, setPageData, acsMgmt, loginData, false);

  return (
    <div id="AdvFormSearch" className="pad-1-lr" css={advFormStyles['.container']}>
      <AdvFormHeader
        pageData={pageData}
        setPageData={setPageData}
        toggleAdvFormSearch={toggleAdvFormSearch}
        showSaveSearch={showSavedSearch}
        savedSearchList={savedSearchList}
        showPopup={showSaveListPopup}
        setShowPopup={setShowSaveListPopup}
        onItemClick={onItemClick}
        handleFormReset={handleFormReset}
      />
      <div className="col-md-12">
        {formFields}
        {isForFileTrack && (
        <AdvAppFormItem
          pageData={pageData}
          setPageData={setPageData}
          acsMgmt={acsMgmt}
          loginData={loginData}
        />
        )}
      </div>
      <AdvFormActionButtons
        leftButtonName="Reset"
        rightButtonName="Search"
        handleFormLeftButton={handleFormReset}
        handleFormRightButton={handleFormSubmit}
      />
    </div>
  );
};

AdvFormSearch.displayName = 'AdvFormSearch';

AdvFormSearch.propTypes = {
  advFormData: PropTypes.shape({
    formFields: PropTypes.arrayOf(
      PropTypes.shape({
        value: PropTypes.string.isRequired,
      })),
  }).isRequired,
  setAdvFormData: PropTypes.func.isRequired,
  handleAdvFormSearchClick: PropTypes.func.isRequired,
  toggleAdvFormSearch: PropTypes.func.isRequired,
  // eslint-disable-next-line react/boolean-prop-naming
  retainValues: PropTypes.bool,
  intlFormData: PropTypes.shape({
    formFields: PropTypes.arrayOf(
      PropTypes.shape({
        value: PropTypes.string.isRequired,
        displayValue: PropTypes.string,
        selectedIds: PropTypes.arrayOf,
      })
    ),
  }),
  acsMgmt: PropTypes.node,
  handleFormChange: PropTypes.func,
  loginData: PropTypes.shape({}),
  savedSearchList: PropTypes.arrayOf(PropTypes.shape({})),
  isForFileTrack: PropTypes.bool.isRequired,
  showSavedSearch: PropTypes.bool,
  onItemClick: PropTypes.func,
  resetHandlerTriggered: PropTypes.func,
  setFormErrorData: PropTypes.func,
};

export default AdvFormSearch;
